import { IonIcon } from '@ionic/react'
import React from 'react'
import Calendar, { CalendarProps } from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import './date-picker.scss'
import { icon_arrow_sx, icon_arrow_dx } from 'icons'
import { dateService, storageService } from 'services'

const DatePicker: React.FC<CalendarProps> = (props) => {
  const max_date = props.maxDate || dateService.getMaxDatePicker()

  return (
    <Calendar
      {...props}
      className="edisu-date-picker"
      prevLabel={<IonIcon icon={icon_arrow_sx} />}
      nextLabel={<IonIcon icon={icon_arrow_dx} />}
      prev2Label={null}
      next2Label={null}
      maxDate={max_date}
      locale={storageService.getLanguage()!}
    />
  )
}

export default DatePicker
